import React, { Fragment } from "react";
import { connect } from "react-redux";
import OrderReceivedSec from "../../components/OrderRecivedSec";

// 🧾 Define Cart Item Type (same as in OrderReceivedSec)
interface CartItem {
  id: number | string;
  title: string;
  proImg?: string;
  price: number;
  qty: number;
}

// 🧩 Define Props Interface for Component
interface OrderReceivedProps {
  cartList: CartItem[];
  symbol?: string;
}

const OrderReceived: React.FC<OrderReceivedProps> = ({ cartList }) => {
  return (
    <Fragment>
      <OrderReceivedSec cartList={cartList} />
    </Fragment>
  );
};

// 🧩 Redux State Mapping (Typed)
const mapStateToProps = (state: any) => ({
  cartList: state.cartList.cart,
  symbol: state.data.symbol,
});

export default connect(mapStateToProps)(OrderReceived);
